import React from "react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-black mb-3">404</h1>
        <p className="text-white/60">Sayfa bulunamadı.</p>
      </div>
    </div>
  );
}